module.exports = __webpack_public_path__ + "img/fuego.2e7ab164.png";